import * as $ from 'jquery';
import 'bootstrap';
import 'selectize';
import 'datepicker';
import { loginForm } from './c005-login';
import { adobeDataLayerWrapper } from "./adobeDataLayerMethod";
export class inflightMenu{
	private sourceOndList: any= [];
	private destOndList: any= [];
  private selectedDestinationObj: any = {
    origin: null,
    destination: null,
    cabin: null,
    flightDate: null,
  };
  private selectedFlightNumberObj: any = {
    cabin: null,
    flightDate: null,
    flightNumber: null,
  };

  processDestinationsForm() {
    let _self = this;
    let $descriptionFromLocationContainer: any = null;
	let $descriptionFromLocation: any = null;
    let $descriptionDestContainer: any = null;
	let $descriptionDest: any = null;
    let $destinationTabDate: any = null;
    let $destinationTabDateContainer: any = null;
    let $destinationCabin: any = null;
	let $destinationCabinContainer: any = null;
	let $errorsInfo: any = null;
	let destinationSearchBtn:any = null;
	let timerValue : any = null;
	let $destinationFlight: any = null;
	let $destinationFlightContainer: any = null;
	let $destinationFLightDownloadBtn:any = null;
    if(!_self.isMobile()) {
      $descriptionFromLocationContainer = $('.destinationTabFromLocation');
      $descriptionFromLocation = $('#destinationTabFromLocation');
      $descriptionDestContainer = $('.destinationTabToLocation');
      $descriptionDest = $('#destinationTabToLocation');
      $destinationTabDate = $('#destinationTabDate');
      $destinationTabDateContainer = $('.destinationTabDate');
      $destinationCabin = $('#destinationTabCabin');
      $destinationCabinContainer = $('.destinationTabCabin');
	  $destinationFlight = $("#destinationTabFlight");
	  $destinationFlightContainer =$(".destinationTabFlight");
      $errorsInfo = $(".errors-info");
	  destinationSearchBtn = $('.destination-search');
	  timerValue = $('#timerValue');
	  $destinationFLightDownloadBtn=$('.destination-download-url');
	  
    } else {
      $descriptionFromLocationContainer = $('.mobDestinationTabFromLocation');
      $descriptionFromLocation = $('#mobDestinationTabFromLocation');
      $descriptionDestContainer = $('.mobDestinationTabToLocation');
      $descriptionDest = $('#mobDestinationTabToLocation');
      $destinationTabDate = $('#mobDestinationTabDate');
      $destinationTabDateContainer = $('.mobDestinationTabDate');
      $destinationCabin = $('#mobDestinationTabCabin');
      $destinationCabinContainer = $('.mobDestinationTabCabin');
			$errorsInfo = $(".mob-errors-info");
			destinationSearchBtn = $('.mob-destination-search');
			timerValue = $('#mob-timerValue');
			$destinationFlight = $("#mobdestinationTabFlight");
			$destinationFlightContainer =$(".mobdestinationTabFlight");
			$destinationFLightDownloadBtn=$('.mob-destination-download-url')
    }
    
    let $selectTo = $descriptionDest.selectize({
			valueField: 'code',
			labelField: 'airportName',
			searchField: 'airportName',
			options: _self.destOndList,
			optgroups: [
				{value: 'wmh', label: 'With Malaysia Airlines'},
			],
			optgroupField: 'class',
			onFocus: function() {
				$descriptionDestContainer.find('.booking-form--title').addClass('input-filled');
				$descriptionDestContainer.find('.selectize-control.single .selectize-input').addClass('select-filled');
				$descriptionDestContainer.find('.selectize-control .selectize-input').removeClass('has-error');
				$descriptionDestContainer.find('.booking-form--title').removeClass('has-error');
			},
			onBlur: function() {
				let $destLocationChange = $descriptionDest.find('option:selected').text();
				if ($destLocationChange == ''){
					$descriptionDestContainer.find('.booking-form--title').removeClass('input-filled');
					$descriptionDestContainer.find('.selectize-control.single .selectize-input').removeClass('select-filled');
				} else {
					$descriptionDestContainer.find('.booking-form--title').addClass('input-filled');
					$descriptionDestContainer.find('.selectize-control.single .selectize-input').addClass('select-filled');
				}
			},
			onChange: function(value: any) {
				$descriptionDestContainer.find('.booking-form--title').addClass('input-filled');
				$descriptionDestContainer.find('.selectize-control.single .selectize-input').addClass('select-filled');
        _self.selectedDestinationObj.destination = value;
		$destinationFlightContainer.addClass('hide');
		// _self.resetFlightList();
			},
      render: {
        item: function(data:any, escape:any) {
          return '<div class="item">'+escape(data.airportName)+ ' (' + escape(data.code) + ')</div>';
        }
      }
		});
    let selectTo = $selectTo[0].selectize;
    $descriptionFromLocation.selectize({
			valueField: 'index',
			searchField: 'airportName',
			labelField: 'airportName',
			options: _self.sourceOndList,
			optgroups: [
				{value: 'wmh', label: 'With Malaysia Airlines'},
			],
			optgroupField: 'class',
			onChange: function(value: any) {
				if(value) {
					$descriptionFromLocationContainer.find('.booking-form--title').addClass('input-filled');
					$descriptionFromLocationContainer.find('.selectize-control.single .selectize-input').addClass('select-filled');
					let destinationList = JSON.parse(JSON.stringify(_self.sourceOndList));
					destinationList.splice(value, 1);
					_self.selectedDestinationObj.origin = _self.sourceOndList[value].code;
					_self.destOndList = destinationList;
					selectTo.clearOptions();
					selectTo.addOption(_self.destOndList);
					selectTo.open();
					$destinationFlightContainer.addClass('hide');
					// _self.resetFlightList();
				}
			},
			onFocus: function() {
				$descriptionFromLocationContainer.find('.booking-form--title').addClass('input-filled');
				$descriptionFromLocationContainer.find('.selectize-control.single .selectize-input').addClass('select-filled');
				$descriptionFromLocationContainer.find('.selectize-control .selectize-input').removeClass('has-error');
				$descriptionFromLocationContainer.find('.booking-form--title').removeClass('has-error');
			},
			onBlur: function() {
				let $fromLocationChange = $descriptionFromLocationContainer.find('option:selected').text();
				if ($fromLocationChange == ''){
					$descriptionFromLocationContainer.find('.booking-form--title').removeClass('input-filled');
					$descriptionFromLocationContainer.find('.selectize-control.single .selectize-input').removeClass('select-filled');
				} else {
					$descriptionFromLocationContainer.find('.booking-form--title').addClass('input-filled');
					$descriptionFromLocationContainer.find('.selectize-control.single .selectize-input').addClass('select-filled');
				}
			},
      render: {
        item: function(data:any, escape:any) {
          return '<div class="item">'+escape(data.airportName)+ ' (' + escape(data.code) + ')</div>';
        }
      }
		});
    let date = new Date();
		let currentMonth = date.getMonth();
		let currentDate = date.getDate();
		let currentYear = date.getFullYear();
    $destinationTabDate.datepicker({
			numberOfMonths: 2,
			minDate: new Date(currentYear, currentMonth, currentDate),
			maxDate: new Date(currentYear, currentMonth+2, currentDate),
      dateFormat: 'yy-mm-dd',
			onSelect: function(date: any) {
        _self.selectedDestinationObj.flightDate = date;
        $destinationTabDate.removeClass('has-error');
		$destinationTabDateContainer.removeClass('has-error');
        $destinationTabDateContainer.find('.booking-form--title').addClass('input-filled');
    	},
		beforeShow: function(ele:any, obj:any) {
			if($('.ibe-refresh').length >0) {
				$('#ui-datepicker-div').addClass('ibe-refresh-datepicker');
			}
		}
		});
    $destinationTabDate.focus(function() {
			$destinationTabDateContainer.find('.booking-form--title').removeClass('has-error');
			$destinationTabDateContainer.find('.booking-form--title').addClass('input-filled');
		});
		$destinationTabDate.blur(function() {
			if($destinationTabDate.val() == "") {
				$destinationTabDateContainer.find('.booking-form--title').removeClass('input-filled');
			} else {
				$destinationTabDateContainer.find('.booking-form--title').addClass('input-filled');
			}
		});
    $destinationTabDate.change(function() {
			$destinationTabDateContainer.find('.booking-form--title').addClass('input-filled');
			$destinationFlightContainer.addClass('hide');
			// _self.resetFlightList();
		});

    $destinationCabin.selectize({
			valueField: 'code',
			labelField: 'title',
			searchField: 'title',
			options: [
				{id: 1, title: 'Economy', code: 'E'},
				{id: 2, title: 'Business', code: 'B'},
				{id: 3, title: 'Business Suite', code: 'F'}
			],
			onFocus: function() {
				$destinationCabinContainer.find('.booking-form--title').addClass('input-filled');
				$destinationCabinContainer.find('.selectize-control.single .selectize-input').addClass('select-filled');
				$destinationCabinContainer.find('.selectize-control .selectize-input').removeClass('has-error');
				$destinationCabinContainer.find('.booking-form--title').removeClass('has-error');
			},
			onBlur: function() {
				let $cabin = $destinationCabin.find('option:selected').text();
				if ($cabin == ''){
					$destinationCabinContainer.find('.booking-form--title').removeClass('input-filled');
					$destinationCabinContainer.find('.selectize-control.single .selectize-input').removeClass('select-filled');
				} else {
					$destinationCabinContainer.find('.booking-form--title').addClass('input-filled');
					$destinationCabinContainer.find('.selectize-control.single .selectize-input').addClass('select-filled');
				}
			},
			onChange: function(value: any) {
				$destinationCabinContainer.find('.booking-form--title').addClass('input-filled');
				$destinationCabinContainer.find('.selectize-control.single .selectize-input').addClass('select-filled');
        _self.selectedDestinationObj.cabin = value;
		$destinationFlightContainer.addClass('hide');
		// _self.resetFlightList();
			}
		});
		
    // click on search button
    destinationSearchBtn.click(function() {
		adobeDataLayer.push('click', {
			'clickName': 'click:btn-click:manage-inflight-menu-search',
			'componentType': 'btn',
			'componentName': 'Manage Inflight Menu',
			'componentID': '',
			'attributes': []
		});
			$errorsInfo.html('');
			let errorStr = '';
			$descriptionFromLocationContainer.find('.selectize-control .selectize-input').removeClass('has-error');
			$descriptionFromLocationContainer.find('.booking-form--title').removeClass('has-error');
			$descriptionDestContainer.find('.selectize-control .selectize-input').removeClass('has-error');
			$descriptionDestContainer.find('.booking-form--title').removeClass('has-error');
			$destinationCabinContainer.find('.selectize-control .selectize-input').removeClass('has-error');
			$destinationCabinContainer.find('.booking-form--title').removeClass('has-error');
			$destinationTabDate.removeClass('has-error');
			$destinationTabDateContainer.find('.booking-form--title').removeClass('has-error');
			if($descriptionFromLocation.val() == '') {
				$descriptionFromLocationContainer.find('.selectize-control .selectize-input').addClass('has-error');
				$descriptionFromLocationContainer.find('.booking-form--title').addClass('has-error');
				errorStr += '<li>From: This value is required.';
			}
			if($descriptionDest.val() == '') {
				$descriptionDestContainer.find('.selectize-control .selectize-input').addClass('has-error');
				$descriptionDestContainer.find('.booking-form--title').addClass('has-error');
				errorStr += '<li>To: This value is required.';
			}
			if($destinationCabin.val() == '') {
				$destinationCabinContainer.find('.selectize-control .selectize-input').addClass('has-error');
				$destinationCabinContainer.find('.booking-form--title').addClass('has-error');
				errorStr += '<li>Cabin: This value is required.';
			}
			if($destinationTabDate.val() === '') {
				$destinationTabDate.addClass('has-error');
				$destinationTabDateContainer.addClass('has-error');
        $destinationTabDateContainer.find('.booking-form--title').removeClass('input-filled');
				$destinationTabDateContainer.find('.booking-form--title').addClass('has-error');
				errorStr += '<li>Date: This value is required.';
			}
			if(errorStr != '') {
				errorStr = '<i class="fa fa-exclamation-triangle" aria-hidden="true" style="color:red"></i><ul style="color:red;display:inline-block">' + errorStr + '</ul>';
				if(_self.isMobile()) {
				$('.mob-error-validation-seperator').css('background-color', 'red');
				} else {
				$('.error-validation-seperator').css('background-color', 'red');
				}
				$errorsInfo.html(errorStr);
			} else {
				$('.error-validation-seperator').css('background-color', '#e9e9e9');
				$('.mob-error-validation-seperator').css('background-color', '#e9e9e9');
				let url = "/bin/services/inflightmenucard/sourcedestinationsearch";
				_self.resetFlightList();
				setTimeout(() => {
					// _self.fetchPdfUrl(_self.selectedDestinationObj, url, $errorsInfo, 'destination');
					_self.flightListForPDFUrl(_self.selectedDestinationObj, url, $errorsInfo, 'destination',$destinationFlight,$destinationFlightContainer,$destinationFLightDownloadBtn);
				}, 500);
			}
		});
		$destinationFLightDownloadBtn.click(function() {
			let PDFURL:any=$destinationFLightDownloadBtn.val()
			if(PDFURL){
				window.open(PDFURL);
			}
				

		});

  }
  processFlightNumberForm() {
    let _self = this;
    let $flightNumber: any = null;
    let $flightNumberContainer: any = null;
    let $inflightCabin: any = null;
    let $inflightCabinContainer: any = null;
    let $flightNumberDate: any = null;
    let $flightNumberdateContainer: any = null;
		let $inFlightErrorInfo: any = null;
		let flightNumberSearch: any = null
		let timerValue: any = null;
    if(!this.isMobile()) {
      $flightNumber = $('#flightNumber');
      $flightNumberContainer = $('.flightNumber');
      $inflightCabin = $('#flightNumberCabin');
      $inflightCabinContainer = $('.flightNumberCabin');
      $flightNumberDate = $('#flightNumberDate');
      $flightNumberdateContainer = $('.flightNumberDate');
			$inFlightErrorInfo = $(".errors-info-inflight");
			flightNumberSearch = $('.flight-number-search');
			timerValue = $('#timerValue');
    } else {
      $flightNumber = $('#mobFlightNumber');
      $flightNumberContainer = $('.mobFlightNumber');
      $inflightCabin = $('#mobFlightNumberCabin');
      $inflightCabinContainer = $('.mobFlightNumberCabin');
      $flightNumberDate = $('#mobFlightNumberDate');
      $flightNumberdateContainer = $('.mobFlightNumberDate');
			$inFlightErrorInfo = $(".mob-errors-info-inflight");
			flightNumberSearch = $('.mob-flight-number-search');
			timerValue = $('#mob-timerValue');
    }
    let date = new Date();
		let currentMonth = date.getMonth();
		let currentDate = date.getDate();
		let currentYear = date.getFullYear();
    
    // inflight fields starts
    $flightNumber.focus(function() {
			$flightNumberContainer.find('.booking-form--title').removeClass('has-error');
			$flightNumber.removeClass('has-error');
		});
		$flightNumber.blur(function() {
			if($flightNumber.val() != "") {
        _self.selectedFlightNumberObj.flightNumber = $flightNumber.val();
				$flightNumber.removeClass('has-error');
			}
		});
	
    $inflightCabin.selectize({
			valueField: 'code',
			labelField: 'title',
			searchField: 'title',
			options: [
				{id: 1, title: 'Economy', code: 'E'},
				{id: 2, title: 'Business', code: 'B'},
				{id: 3, title: 'Business Suite', code: 'F'}
			],
			onFocus: function() {
				$inflightCabinContainer.find('.booking-form--title').addClass('input-filled');
				$inflightCabinContainer.find('.selectize-control.single .selectize-input').addClass('select-filled');
				$inflightCabinContainer.parent().find('.selectize-control .selectize-input').removeClass('has-error');
				$inflightCabinContainer.parent().find('.booking-form--title').removeClass('has-error');
			},
			onBlur: function() {
				let $cabin = $inflightCabin.find('option:selected').text();
				if ($cabin == ''){
					$inflightCabinContainer.find('.booking-form--title').removeClass('input-filled');
					$inflightCabinContainer.find('.selectize-control.single .selectize-input').removeClass('select-filled');
				} else {
					$inflightCabinContainer.find('.booking-form--title').addClass('input-filled');
					$inflightCabinContainer.find('.selectize-control.single .selectize-input').addClass('select-filled');
				}
			},
			onChange: function(value: any) {
				$inflightCabinContainer.find('.booking-form--title').addClass('input-filled');
				$inflightCabinContainer.find('.selectize-control.single .selectize-input').addClass('select-filled');
        _self.selectedFlightNumberObj.cabin = value;
	
			}
		});
    
    $flightNumberDate.datepicker({
			numberOfMonths: 2,
			minDate: new Date(currentYear, currentMonth, currentDate),
			maxDate: new Date(currentYear, currentMonth+2, currentDate),
      dateFormat: 'yy-mm-dd',
			onSelect: function(date: any) {
        $flightNumberDate.removeClass('has-error');
				$flightNumberdateContainer.removeClass('has-error');
        $flightNumberdateContainer.find('.booking-form--title').addClass('input-filled');
        _self.selectedFlightNumberObj.flightDate = date;
    	},
		beforeShow: function(ele:any, obj:any) {
			if($('.ibe-refresh').length >0) {
				$('#ui-datepicker-div').addClass('ibe-refresh-datepicker');
			}
		}
		});
		$flightNumberDate.focus(function() {
			$flightNumberdateContainer.find('.booking-form--title').removeClass('has-error');
			$flightNumberdateContainer.find('.booking-form--title').addClass('input-filled');
		});
		$flightNumberDate.blur(function() {
			if($flightNumberDate.val() == "") {
				$flightNumberdateContainer.find('.booking-form--title').removeClass('input-filled');
			} else {
				$flightNumberdateContainer.find('.booking-form--title').addClass('input-filled');
			}
		});
    $flightNumberDate.change(function() {
			$flightNumberdateContainer.find('.booking-form--title').addClass('input-filled');
		
		});
		flightNumberSearch.click(function() {
			$inFlightErrorInfo.html('');
			let errorStr = '';
			if($flightNumber.val() === '') {
				errorStr += '<li>Flight Number: Please enter 4 digit flight number';
				$flightNumberContainer.find('.booking-form--title').addClass('has-error');
				$flightNumber.addClass('has-error');
			}
			if($flightNumber.val().length > 0 && $flightNumber.val().length !== 4) {
				errorStr += '<li>Flight Number: Must only be 4 digit.';
				$flightNumberContainer.find('.booking-form--title').addClass('has-error');
				$flightNumber.addClass('has-error');
			}
			if($inflightCabin.val() === '') {
				$inflightCabin.addClass('has-error');
				$inflightCabinContainer.find('.selectize-control .selectize-input').addClass('has-error');
				$inflightCabinContainer.find('.booking-form--title').addClass('has-error');
				errorStr += '<li>Cabin: This value is required.';
			}
			if($flightNumberDate.val() === '') {
				$flightNumberdateContainer.addClass('has-error');
        $flightNumberdateContainer.find('.booking-form--title').removeClass('input-filled');
				$flightNumberdateContainer.find('.booking-form--title').addClass('has-error');
				errorStr += '<li>Date: This value is required.';
			}
			if(errorStr != '') {
				errorStr = '<i class="fa fa-exclamation-triangle" aria-hidden="true" style="color:red"></i><ul style="color:red;display:inline-block">' + errorStr + '</ul>';
        if(_self.isMobile()) {
          $('.mob-error-validation-seperator-inflight').css('background-color', 'red');
        } else {
          $('.error-validation-seperator-inflight').css('background-color', 'red');
        }
				$inFlightErrorInfo.html(errorStr);
			} else {
				$('.error-validation-seperator-inflight').css('background-color', '#e9e9e9');
				$('.mob-error-validation-seperator-inflight').css('background-color', '#e9e9e9');
				let url = "/bin/services/inflightmenucard/flightnumbersearch";
				setTimeout(() => {
					_self.fetchPdfUrl(_self.selectedFlightNumberObj, url, $inFlightErrorInfo, 'inflight');
				}, 500);
			}
		});
	}
  initializeDropdown() {
		let self = this;
		let ondList: string = $('[data-ond-list-url]').attr('data-ond-list-url');
		$.ajax({
			type: 'GET',
			url: ondList,
			async: false,
			success: function (ondData: any) {
				self.processONDData(ondData);
			},
			error: function (msg: any) {
			}
		});
	}
  processONDData(ondData: any) {
		this.sourceOndList = [];
		this.destOndList = [];
		let list: any = [];
		if(ondData) {
			let sourceKeys = Object.keys(ondData.response);
			let response = ondData.response;
			sourceKeys.map((k, index) => {
				list.push({
					class: 'wmh',
					airportName: response[k].airportName,
					source: response[k],
					code: response[k].airportCode,
				});
			});
			list.sort(function(a:any, b:any){
				if(a.airportName < b.airportName) { return -1; }
				if(a.airportName > b.airportName) { return 1; }
				return 0;
			});
			list.map((item:any, index:any) => {
				item['index'] = index;
			});
			this.sourceOndList = list;
			this.destOndList = list;
		}
	}
  fetchPdfUrl(params: any, url: any, errorContainer: any, search:any) {
		let _self = this;
		$.ajax({
			type: 'POST',
			url: url,
			data: params,
			async: false,
			success: function (pdfData: any) {
				let json = JSON.parse(pdfData);
        if(!json.isValidRequest) {
					errorContainer.html('<i class="fa fa-exclamation-triangle" aria-hidden="true" style="color:red"></i><ul style="color:red"><li><b>Menu not available.</b> Please try again with different input.</li></ul>');
					if(_self.isMobile()) {
						if(search == 'destination') {
							$('.mob-error-validation-seperator').css('background-color', 'red');
						} else {
							$('.mob-error-validation-seperator-inflight').css('background-color', 'red');
						}
					} else {
						if(search == 'destination') {
							$('.error-validation-seperator').css('background-color', 'red');
						} else {
							$('.error-validation-seperator-inflight').css('background-color', 'red');
						}
					}
        } else {
					window.open(json.pdfURL);
        }
			},
			error: function (msg: any) {
				
			}
		});
	};
	flightListForPDFUrl(params: any, url: any, errorContainer: any, search:any,$destinationFlight:any,$destinationFlightContainer:any,$destinationFLightDownloadBtn:any) {
		let _self = this;
		let inflightURL:string=''; 
		if (window.location.hostname === 'localhost' && window.location.port == "5000") {
			inflightURL = '/dummy-data/inFlightListDestination.json';
		}
		else{
			inflightURL = url;
		}
		$.ajax({
			type: 'POST',
			url: inflightURL,
			data: params,
			async: false,
			success: function (jsonData: any) {
			let string1 = JSON.stringify(jsonData);
     	    let json = JSON.parse(string1); 		
				
        if(!json.isValidRequest) {
					errorContainer.html('<i class="fa fa-exclamation-triangle" aria-hidden="true" style="color:red"></i><ul style="color:red"><li><b>Menu not available.</b> Please try again with different input.</li></ul>');
					if(_self.isMobile()) {
						if(search == 'destination') {
							$('.mob-error-validation-seperator').css('background-color', 'red');
						} else {
							$('.mob-error-validation-seperator-inflight').css('background-color', 'red');
						}
					} else {
						if(search == 'destination') {
							$('.error-validation-seperator').css('background-color', 'red');
						} else {
							$('.error-validation-seperator-inflight').css('background-color', 'red');
						}
					}
        } else {
			$destinationFlightContainer.removeClass('hide');
			$destinationFLightDownloadBtn.addClass('disabled');
           if(json.data){
			$destinationFlight.selectize({
				valueField: 'menuLink',
				labelField: 'flightCode',
				searchField: 'title',
				options: json.data ? json.data:null,
				
				onFocus: function() {
					$destinationFlightContainer.find('.booking-form--title').addClass('input-filled');
					$destinationFlightContainer.find('.selectize-control.single .selectize-input').addClass('select-filled');
					$destinationFlightContainer.find('.selectize-control .selectize-input').removeClass('has-error');
					$destinationFlightContainer.find('.booking-form--title').removeClass('has-error');
				},
				onBlur: function() {
					let $flight = $destinationFlight.find('option:selected').text();
					if ($flight == ''){
						$destinationFlightContainer.find('.booking-form--title').removeClass('input-filled');
						$destinationFlightContainer.find('.selectize-control.single .selectize-input').removeClass('select-filled');
					} else {
						$destinationFlightContainer.find('.booking-form--title').addClass('input-filled');
						$destinationFlightContainer.find('.selectize-control.single .selectize-input').addClass('select-filled');
					}
				},
				onChange: function(value: any) {
					$destinationFlightContainer.find('.booking-form--title').addClass('input-filled');
					$destinationFlightContainer.find('.selectize-control.single .selectize-input').addClass('select-filled');
			_self.selectedDestinationObj.flight = value;
			_self.appendFlightPDFURL(value,$destinationFLightDownloadBtn);

				}
			});	

		   }
        }
			},
			error: function (msg: any) {                
                if(msg.responseJSON){
                    let errorjson = msg.responseJSON; 
                    if( errorjson.isValidRequest===false) {
                        errorContainer.html('<i class="fa fa-exclamation-triangle" aria-hidden="true" style="color:red"></i><ul style="color:red"><li><b>Menu not available.</b> Please try again with different input.</li></ul>');
                        if(_self.isMobile()) {
                            if(search == 'destination') {
                                $('.mob-error-validation-seperator').css('background-color', 'red');
                            } else {
                                $('.mob-error-validation-seperator-inflight').css('background-color', 'red');
                            }
                        } else {
                            if(search == 'destination') {
                                $('.error-validation-seperator').css('background-color', 'red');
                            } else {
                                $('.error-validation-seperator-inflight').css('background-color', 'red');
                            }
                        }
                    }
                }
                else if(msg.status===404){
                    errorContainer.html('<i class="fa fa-exclamation-triangle" aria-hidden="true" style="color:red"></i><ul style="color:red"><li><b>Menu not available.</b> Please try again with different input.</li></ul>');
                    if(_self.isMobile()) {
                        if(search == 'destination') {
                            $('.mob-error-validation-seperator').css('background-color', 'red');
                        } else {
                            $('.mob-error-validation-seperator-inflight').css('background-color', 'red');
                        }
                    } else {
                        if(search == 'destination') {
                            $('.error-validation-seperator').css('background-color', 'red');
                        } else {
                            $('.error-validation-seperator-inflight').css('background-color', 'red');
                        }
                    }
                }     
            }
		});

	};
	appendFlightPDFURL(flightURL:any,$destinationFLightDownloadBtn:any){
		if(flightURL){
			$destinationFLightDownloadBtn.attr("value",flightURL); 
			$destinationFLightDownloadBtn.removeClass('disabled');
		}
		else{
			$destinationFLightDownloadBtn.addClass('disabled');

		}
	

	}
	resetFlightList(){
		var $sel,control;
		$sel=$("#destinationTabFlight").selectize();
		control = $sel[0].selectize;
		control.destroy();
		$sel=$("#mobdestinationTabFlight").selectize();
		control = $sel[0].selectize;
		control.destroy();
		// $('#destinationTabFlight option').prop('selected', function() {
		// 	return this.defaultSelected;
		// });
		// $('#mobdestinationTabFlight option').prop('selected', function() {
		// 	return this.defaultSelected;
		// });
	}
	resetDestinationFields() {
		// destination
		$('.error-validation-seperator').css('background-color', '#e9e9e9');
		$('.mob-error-validation-seperator').css('background-color', '#e9e9e9');
		$('.errors-info').html('');
		$('.mob-errors-info').html('');
		var $sel, control;
		$sel = $('#destinationTabFromLocation').selectize();
		control = $sel[0].selectize;
		control.clear();
		$sel = $('#destinationTabToLocation').selectize();
		control = $sel[0].selectize;
		control.clear();
		$sel = $('#destinationTabCabin').selectize();
		control = $sel[0].selectize;
		control.clear();
	
		$sel = $('#destinationTabDate').datepicker('setDate', null);
		$('.destinationTabFromLocation').find('.booking-form--title').removeClass('input-filled');
		$('.destinationTabFromLocation').find('.selectize-control.single .selectize-input').removeClass('select-filled');
		$('.destinationTabFromLocation').find('.selectize-control .selectize-input').removeClass('has-error');
		$('.destinationTabFromLocation').find('.booking-form--title').removeClass('has-error');
		
		$('.destinationTabToLocation').find('.booking-form--title').removeClass('input-filled');
		$('.destinationTabToLocation').find('.selectize-control.single .selectize-input').removeClass('select-filled');
		$('.destinationTabToLocation').find('.selectize-control .selectize-input').removeClass('has-error');
		$('.destinationTabToLocation').find('.booking-form--title').removeClass('has-error');

		$('.destinationTabCabin').find('.booking-form--title').removeClass('input-filled');
		$('.destinationTabCabin').find('.selectize-control.single .selectize-input').removeClass('select-filled');
		$('.destinationTabCabin').find('.selectize-control .selectize-input').removeClass('has-error');
		$('.destinationTabCabin').find('.booking-form--title').removeClass('has-error');

		$('.destinationTabCabin').find('.booking-form--title').removeClass('input-filled');
		$('.destinationTabCabin').find('.selectize-control.single .selectize-input').removeClass('select-filled');
		$('.destinationTabCabin').find('.selectize-control .selectize-input').removeClass('has-error');
		$('.destinationTabCabin').find('.booking-form--title').removeClass('has-error');

		$('.destinationTabFlight').find('.booking-form--title').removeClass('input-filled');
		$('.destinationTabFlight').find('.selectize-control.single .selectize-input').removeClass('select-filled');
		$('.destinationTabFlight').find('.selectize-control .selectize-input').removeClass('has-error');
		$('.destinationTabFlight').find('.booking-form--title').removeClass('has-error');
		$('.destinationTabFlight').addClass('hide');

		

		$sel = $('#mobDestinationTabFromLocation').selectize();
		control = $sel[0].selectize;
		control.clear();
		$sel = $('#mobDestinationTabToLocation').selectize();
		control = $sel[0].selectize;
		control.clear();
		$sel = $('#mobDestinationTabCabin').selectize();
		control = $sel[0].selectize;
		control.clear();
	
		$sel = $('#mobDestinationTabDate').datepicker('setDate', null);
		$('#mobDestinationTabDate').removeClass('has-error');
		$('.mobDestinationTabFromLocation').find('.booking-form--title').removeClass('input-filled');
		$('.mobDestinationTabFromLocation').find('.selectize-control.single .selectize-input').removeClass('select-filled');
		$('.mobDestinationTabFromLocation').find('.selectize-control .selectize-input').removeClass('has-error');
		$('.mobDestinationTabFromLocation').find('.booking-form--title').removeClass('has-error');
		$('.mobDestinationTabToLocation').find('.booking-form--title').removeClass('input-filled');
		$('.mobDestinationTabToLocation').find('.selectize-control.single .selectize-input').removeClass('select-filled');
		$('.mobDestinationTabToLocation').find('.selectize-control .selectize-input').removeClass('has-error');
		$('.mobDestinationTabToLocation').find('.booking-form--title').removeClass('has-error');

		$('.mobDestinationTabCabin').find('.booking-form--title').removeClass('input-filled');
		$('.mobDestinationTabCabin').find('.selectize-control.single .selectize-input').removeClass('select-filled');
		$('.mobDestinationTabCabin').find('.selectize-control .selectize-input').removeClass('has-error');
		$('.mobDestinationTabCabin').find('.booking-form--title').removeClass('has-error');

		$('#mobDestinationTabDate').removeClass('has-error');
		$('.mobDestinationTabDate').removeClass('has-error');
		$('.mobDestinationTabDate').find('.booking-form--title').removeClass('input-filled');
		$('.mobDestinationTabDate').find('.booking-form--title').removeClass('has-error');

		$('#destinationTabDate').removeClass('has-error');
		$('.destinationTabDate').removeClass('has-error');
		$('.destinationTabDate').find('.booking-form--title').removeClass('input-filled');
		$('.destinationTabDate').find('.booking-form--title').removeClass('has-error');

		$('.mobdestinationTabFlight').addClass('hide');
		$("#mobdestinationTabFlight").selectedIndex = 0;
	};
	resetInflightFields() {
		// flight
		$('.error-validation-seperator-inflight').css('background-color', '#e9e9e9');
		$('.mob-error-validation-seperator-inflight').css('background-color', '#e9e9e9');
		$('.errors-info-inflight').html('');
		$('.mob-errors-info-inflight').html('');
		$('#flightNumber').val(null);
		$('#flightNumber').removeClass('has-error')
		$('.flightNumber').find('.booking-form--title').removeClass('has-error');
		var $sel, control,$flightSelect,control1;
		$sel = $('#flightNumberCabin').selectize();
		control = $sel[0].selectize;
		control.clear();

		$('#flightNumberDate').datepicker('setDate', null);
		$('#mobFlightNumber').val(null)
		$('#mobFlightNumber').removeClass('has-error')
		$('.mobFlightNumber').find('.booking-form--title').removeClass('has-error');

		$sel = $('#mobFlightNumberCabin').selectize();
		control = $sel[0].selectize;
		control.clear();
		$('#mobFlightNumberDate').datepicker('setDate', null);

		$('.flightNumberCabin').find('.booking-form--title').removeClass('input-filled');
		$('.flightNumberCabin').find('.selectize-control.single .selectize-input').removeClass('select-filled');
		$('.flightNumberCabin').find('.selectize-control .selectize-input').removeClass('has-error');
		$('.flightNumberCabin').find('.booking-form--title').removeClass('has-error');
		$('.flightNumberDate').find('.booking-form--title').removeClass('has-error');
		$('.flightNumberDate').removeClass('has-error');

		$('.mobFlightNumberCabin').find('.booking-form--title').removeClass('input-filled');
		$('.mobFlightNumberCabin').find('.selectize-control.single .selectize-input').removeClass('select-filled');
		$('.mobFlightNumberCabin').find('.selectize-control .selectize-input').removeClass('has-error');
		$('.mobFlightNumberCabin').find('.booking-form--title').removeClass('has-error');
		$('.mobFlightNumberDate').find('.booking-form--title').removeClass('has-error');
		$('.mobFlightNumberDate').removeClass('has-error');
	}
  initTabs() {
		let _self = this;
    if(!this.isMobile()) {
      var $radios = $('input:radio[id=destinationTab]');
      if($radios.is(':checked') === false) {
          $radios.prop('checked', true);
      }
      $('.destination-form').show();
      $('.flight-number-form').hide();
	  $('.destinationTabFlight').addClass('hide');
	  $("#destinationTabFlight").selectedIndex = 0;
	  $('.mobdestinationTabFlight').addClass('hide');
	  $("#mobdestinationTabFlight").selectedIndex = 0;
      $('input:radio[name=flight-menu]').click(function() {
        let section = $(this).attr('data-section');
        $('.destination-form').hide()
        $('.flight-number-form').hide();
        $('.'+ section).show();
        $('.'+ section).show();
      });
    } else {
      var $radios = $('input:radio[id=mobDestinationTab]');
      if($radios.is(':checked') === false) {
          $radios.prop('checked', true);
      }
      $('.mob-destination-form').show();
      $('.mob-flight-number-form').hide();
      $('input:radio[name=flight-menu]').click(function() {
        let section = $(this).attr('data-section');
        $('.mob-destination-form').hide()
        $('.mob-flight-number-form').hide();
        $('.'+ section).show();
        $('.'+ section).show();
      });
	}
	if ($('.enrich-revamp').length == 0) {
		$('.book-opt-viewbooking, .book-opt-mhupgrade, .book-opt-nfs, .book-opt-car, .book-flight, .mholidays, .view-booking , .check-in , .flight-status , .flight-upgrade').click(function() {
			_self.resetDestinationFields();
			_self.resetInflightFields();
			_self.resetFlightList();
		});
	}
  }
  isMobile() {
    return (window.innerWidth <= 767);
  }
  
}
let scope:Element = null;
if( window.innerWidth <= 767 ) {
  scope = document.querySelector('#mob-in-flight-menu--container');
} else {
  scope = document.querySelector('#in-flight-menu--container');
}
if (scope){
	try {
		let inflight = new inflightMenu();
		var adobeDataLayer = new adobeDataLayerWrapper();
    inflight.initTabs();
		inflight.initializeDropdown();
		inflight.processDestinationsForm();
    inflight.processFlightNumberForm();
	} catch(e) {console.error(e);}
}